import { getAppInsights } from './telemetry.insight'

export type TelemetryCtx = {
  entry: string
  instanceId?: string
}

type TelemetryGlobal = {
  __telemetry__?: {
    ctx?: TelemetryCtx
  }
}

const g = globalThis as typeof globalThis & TelemetryGlobal

let ctx: TelemetryCtx

export function createTelemetryCtx(entry: string): TelemetryCtx {
  return {
    entry,
    instanceId:
      (crypto as any)?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`
  }
}

export function setTelemetryContext(ctx: TelemetryCtx) {
  g.__telemetry__ ??= {}
  g.__telemetry__.ctx = ctx
}

export function getTelemetryContext(): TelemetryCtx | undefined {
  return g.__telemetry__?.ctx
}

export function trackEntryView(
  connectionString: string,
  entryName: string,
  extra?: Record<string, any>
) {
  const ai = getAppInsights(connectionString)

  ai.trackPageView({
    name: entryName,
    properties: {
      ...extra
    }
  })
}

export function trackCaughtError(
  connectionString: string,
  err: unknown,
  extra?: Record<string, any>,
  ctx?: TelemetryCtx
) {
  const ai = getAppInsights(connectionString)
  const c = ctx ?? getTelemetryContext()

  ai.trackException({
    exception: err instanceof Error ? err : new Error(String(err)),
    properties: {
      entry: c?.entry,
      instanceId: c?.instanceId,
      ...extra
    }
  })
}

export function initEntryTelemetry(
  connectionString: string,
  entryName: string,
  extra?: Record<string, any>
): TelemetryCtx {
  getAppInsights(connectionString)

  const newCtx = createTelemetryCtx(entryName)
  ctx = newCtx
  setTelemetryContext(newCtx)
  trackEntryView(connectionString, entryName, extra)

  return ctx
}

export function getCtxSaved(): TelemetryCtx {
  return ctx
}
